<template>
  <div
    class="flex items-center gap-3 pr-4 min-w-fit"
    :class="{
      'border-r border-base-300': showRightBorder,
      'border-l border-base-300 pl-4': showLeftBorder
    }"
  >
    <div
      v-if="icon || iconUrl || iconComponent"
      class="flex items-center h-10"
      :class="iconRight ? 'order-2' : 'order-1'"
    >
      <span
        :data-tip="tooltip || null"
        :aria-label="tooltip || null"
        :class="[
          'inline-flex overflow-visible',
          tooltip ? 'tooltip' : '',
          tooltip ? placementClass : ''
        ]"
      >
        <component
          v-if="iconComponent"
          :is="iconComponent"
          :class="[iconComponentClass, { sm: iconComponentSm }, roundedIcon]"
          v-bind="iconComponentProps"
        />

        <!-- Fallbacks -->
        <i
          v-else-if="icon"
          :class="[`bi bi-${icon}`, 'text-lg', disabled ? 'text-neutral-400 opacity-50' : 'text-primary']"
        ></i>

        <img
          v-else
          :src="iconUrl"
          :class="[squareIcon ? 'h-7 w-7 rounded-sm' : 'h-5 w-5 rounded-full', { 'grayscale opacity-40': disabled }]"
          :alt="iconAlt"
          @error="onImgError"
        />
      </span>
    </div>

    <!-- Text -->
    <div
      class="flex flex-col gap-0.5 min-w-max justify-center leading-tight"
      :class="iconRight ? 'order-1' : 'order-2'"
    >
      <div :class="[labelFontSize, labelFontWeight, 'text-neutral-400']">
        {{ label }}
      </div>
      <div :class="[valueFontSize, valueFontWeight, 'leading-tight']">
        <p>
          {{ value !== undefined && value !== null && value !== '' ? value : '—' }}
          <routerLink
            v-if="to"
            :to="to"
            class="bi bi-box-arrow-up-right text-accent cursor-pointer ps-1"
            tag="i"
          />
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  label: String,
  value: [String, Number],
  icon: String,
  iconUrl: String,
  iconAlt: String,
  iconComponent: [Function, Object],
  iconComponentClass: { type: String, default: '' },
  iconComponentProps: { type: Object, default: () => ({}) },
  iconComponentSm: { type: Boolean, default: false },
  squareIcon: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  showRightBorder: { type: Boolean, default: false },
  showLeftBorder: { type: Boolean, default: false },
  roundedIcon: { type: String, default: '' },
  labelFontSize: { type: String, default: 'text-xs' },
  labelFontWeight: { type: String, default: 'font-medium' },
  valueFontSize: { type: String, default: 'text-sm' },
  valueFontWeight: { type: String, default: 'font-semibold' },
  iconRight: { type: Boolean, default: false },
  to: [Function, Object],

  // Tooltip opcional (DaisyUI)
  tooltip: { type: String, default: null },
  tooltipPlacement: {
    type: String,
    default: 'top', // top | right | bottom | left
    validator: v => ['top', 'right', 'bottom', 'left'].includes(v)
  }
})

const placementClass = computed(() => `tooltip-${props.tooltipPlacement}`)

function onImgError(e) {
  console.warn(`⚠️ Failed to load icon: ${props.iconUrl}`, e)
}
</script>